import React from 'react';
import debounce from 'lodash/debounce';
import { defineMessages, FormattedMessage } from 'react-intl';
import Segment from '../../components/Segment';

import Header from '../../components/Header';
import ContactsContainer from '../ContactsContainer';
import ContactsListEmpty from '../ContactsContainer/contacts-list-empty';
import PageTitle from '../../components/PageTitle';
import ListHeader from '../ContactsContainer/list-header';
import ExportContactsContainer from './export-contacts';

import './styles.css';

const messages = defineMessages({
  pageHeader: {
    id: 'repvisits.contacts.pageHeader',
    defaultMessage: 'Contacts',
  },
  pageSubHeader: {
    id: 'repvisits.contacts.pageSubHeader',
    // eslint-disable-next-line max-len
    defaultMessage: 'Your Contact list contains all of your RepVisit contacts. Use the search box below to search for an institution.',
  },
});

class RepVisitsContactsPageComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: '',
      filter: '',
      showEmptyMessage: false,
    };
    this.changeFilterDebounce = debounce(this.changeFilter, 400);
  }

  changeSearchValue = (e, { value }) => {
    value = value || e.target.value;
    this.setState({ searchValue: value });
    this.changeFilterDebounce(value);
  };

  changeFilter = (filter) => {
    this.setState({ filter });
  }

  displayEmptyMessage = () => {
    this.setState({ showEmptyMessage: true });
  }

  render() {
    const { searchValue, filter, showEmptyMessage } = this.state;
    return (
      <div styleName="wrapper">
        <PageTitle subTitle="Contacts" title="RepVisits" category="Intersect" />
        <div styleName="container">
          <header styleName="header-container">
            <Header as="h1" styleName="page-header" id="pageTitle"><FormattedMessage {...messages.pageHeader} /></Header>
            <Header.Subheader styleName="sub-header"><FormattedMessage {...messages.pageSubHeader} /></Header.Subheader>
            {!showEmptyMessage && <ExportContactsContainer />}
          </header>
          <Segment.Group styleName="contacts-container">
            {showEmptyMessage && <ContactsListEmpty />}
            {!showEmptyMessage && <ListHeader searchValue={searchValue} onSearchChange={this.changeSearchValue} />}
            {!showEmptyMessage && <ContactsContainer filter={filter} onEmptyResults={this.displayEmptyMessage} />}
          </Segment.Group>
        </div>
      </div>
    );
  }
}

export default RepVisitsContactsPageComponent;
